module.exports = __webpack_public_path__ + "static/media/KMH_4894.90a39df4.jpg";